import {Aluno, Detalhamento, Solicitacao} from "@/models/sie-pedidos/solicitacao";


interface HeaderItemTableSiePedidos {
  text: string;
  align: string;
  sortable: Boolean;
  value: string;
  width?: string,
}

export interface PaginationTableSiePedidos {
  numeroSolicitacao?: number;
  entidadeId: number;
  cpf?: string;
  situacao?: number;
  tipoSolicitacaoId?: string;
  dataInicio?: string;
  dataFim?: string;
  loteId: number,
  page: number;
  size: number;
}


export interface TableSiePedidos {
  dadosFilterSolicitacao: DadosFilterSolicitacao;
  header: HeaderItemTableSiePedidos[];
  content: Solicitacao[];
  paginate: PaginationTableSiePedidos;
  isLoading: Boolean;
  total: Number;
}

export interface ModelDados {
  id: Number;
  descricao: string
}

export interface DadosFilterSolicitacao {
  listSituacao: ModelDados[];
  listTipoSolicitacao: ModelDados[]
}

const dadosFilterSolicitacao: DadosFilterSolicitacao = {
  listSituacao: [],
  listTipoSolicitacao: []
}

const header: HeaderItemTableSiePedidos[] = [
  {
    text: "Número ",
    align: "start",
    sortable: true,
    value: "numeroSolicitacao"
  },
  {
    text: "Lote",
    align: "start",
    sortable: true,
    value: "loteId"
  },
  {
    text: "CPF",
    align: "start",
    sortable: true,
    value: "cpf"
  },
  {
    text: "Status",
    align: "start",
    sortable: true,
    value: "situacao"
  },
  {
    text: "Tipo",
    align: "start",
    sortable: true,
    value: "tipoSolicitacao"
  },
  {
    text: "Motivo",
    align: "start",
    sortable: true,
    value: "motivo",
    width: '25%'
  },
  {
    text: "Data",
    align: "start",
    sortable: true,
    value: "dataSolicitacao"
  },
  {
    text: "Ações",
    align: "start",
    sortable: false,
    value: "acoes"
  }
]

const content: Solicitacao[] = []

const paginate: PaginationTableSiePedidos = {
  numeroSolicitacao: null,
  entidadeId: null,
  cpf: null,
  situacao: null,
  dataInicio: null,
  dataFim: null,
  tipoSolicitacaoId: null,
  loteId: null,
  page: 0,
  size: 10,
}

const tableState: TableSiePedidos = {
  dadosFilterSolicitacao,
  header,
  content,
  paginate,
  isLoading: false,
  total: 0
}
const aluno: Aluno ={
  cpf: null,
  nome: null,
}
const detalhamento : Detalhamento = {
  id: null,
  aluno: aluno,
  motivo: null,
  situacaoSolicitacao: null,
  tipoSolicitacao: null,
  dataSolicitacao: null,
  listDocumentos: []
}

export {tableState, detalhamento}
